import { Component, OnInit } from '@angular/core';
import {ClientServiceService} from '../../client/client-service/client-service.service';
import {ClientteamServiceService} from '../clientteam-service/clientteam-service.service';
import {ActivatedRoute, Router} from '@angular/router';
import {first} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';
import {UserServiceService} from '../../user/user-service/user-service.service';

@Component({
  selector: 'app-clientteam-view',
  templateUrl: './clientteam-view.component.html',
  styleUrls: ['./clientteam-view.component.css']
})
export class ClientteamViewComponent implements OnInit {

    itemsPerPage = 10;
    currentPage = 1;
    CREATE_TEAM_MEMBER: boolean;
    currentUser: any;
    currentUserPermission: any = [];
    public noOfClientTeam: any;
    cId: any;
    clientId: any;
    client: any

    // tslint:disable-next-line:max-line-length
    constructor(private clientteamServiceService: ClientteamServiceService, private _route: ActivatedRoute, private clientService: ClientServiceService, private toastr: ToastrService, private userService: UserServiceService, private router: Router) {
      this._route.fragment.subscribe(fragment => { this.cId = fragment; });
      this.clientId = this.cId !== undefined ? this.cId : localStorage.getItem('clientId');
      this.client = this.getClientDetails(this.clientId);
  }
  public clientContactList: any = [];
  public loading = true;
  ngOnInit() {
      this.currentUser = JSON.parse(localStorage.getItem('user'));
      this.currentUserPermission = this.currentUser.permissions[localStorage.getItem('clientId')];
      for (let i = 0; i < this.currentUserPermission.length; i++) {
          if (this.currentUserPermission[i].indexOf('CREATE_TEAM_MEMBER') >= 0) {
              console.log('Enable CREATE_TEAM_MEMBER Permission');
              this.CREATE_TEAM_MEMBER = true;
              break;
          }
      }
      this.getAllClientContactList();
  }

  public getAllClientContactList() {
    this.loading = true;
    this.clientteamServiceService.getAllClientContacts(this.clientId, this.currentPage - 1, '', this.itemsPerPage )
        .subscribe(data => {
          const response: any = data.json();
          this.clientContactList = response.clientContacts;
          this.noOfClientTeam = response.numberOfClientContact;
          this.loading = false;
          // TODO - Uncomment below code when using actual API
          // const response: any = data;
          // if (response.status === 200) {
          //   this.userList = response.result;
          // } else {
          //   this.toastr.error('', 'Please try again');
          // }
        }, (error) => {
          this.loading = false;
          // this.toastr.error('', 'Please try again');
        });
  }

    pageChanged(event) {
        this.currentPage = event;
        this.getAllClientContactList();
        console.log(event);
    }

    public getClientDetails(clientId: any) {
        this.clientService.getClientById(clientId)
            .pipe(first())
            .subscribe(data => {
                console.log('client ::' + data.json())
                this.client = data.json();
            }, (error) => {
                this.toastr.error('', 'Please try again');
            });
    }

    resendConfirmation(userId) {
        console.log('Resend Confirmation Email: ' + userId);
        this.userService.resendConfirmationEmail(userId).subscribe(data => {
            console.log('Resend confirmation email successful');
            this.toastr.success('', 'Successfully sent confirmation email!');
        }, (error: any) => {
            this.loading = false;
            this.toastr.error('', 'Failed to resend confirmation email, please try later!');
        });

    }

    resetPassword(userId) {
        console.log('Reset Password: ' + userId);
        this.userService.resetPassword(userId).subscribe(data => {
            console.log('Reset Password successful');
            this.toastr.success('', 'Reset password successful!');
        }, (error) => {
            this.loading = false;
            // this.toastr.error('', 'Please try again');
        });

    }

    public addClientTeamMember(clientId, clientName) {
        this.router.navigate( [ '/elasticcare/add/client/team' , {clientIdParam: this.clientId}]);
    }

}
